export const textBoxStyle = {
  width: '48px',
  height: '30px',
  textAlign: 'center',
};
